import ChannelListTipContainer from '@components/atoms/container/channelListTipContainer';
import Tip from '../tip/tip';

export default function ChannelListTip() {
  return (
    <ChannelListTipContainer id={'channelListTipContainer'}>
      <Tip />
    </ChannelListTipContainer>
  );
}
